/*
 * File: UISwitch.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2019 MacPractice, Inc. All rights reserved.
 *
 * Description: Formatting for a Switch input element
 */
import React from "react";
import Switch from "@material-ui/core/Switch";
import { FormControlLabel } from "@material-ui/core";
import PropTypes from "prop-types";

const UISwitch = ({
  value,
  switchOnChange,
  disabled,
  name,
  id,
  formControlLabel
}) => {
  const handleChange = e => {
    if (typeof switchOnChange === "function") {
      switchOnChange(e);
    }
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={value}
          onChange={handleChange}
          value={value}
          color="primary"
          disabled={disabled}
          name={name}
          id={id}
        />
      }
      label={formControlLabel}
    />
  );
};

UISwitch.propTypes = {
  value: PropTypes.bool.isRequired,
  switchOnChange: PropTypes.func,
  disabled: PropTypes.bool,
  name: PropTypes.string,
  formControlLabel: PropTypes.node,
  id: PropTypes.string
};

export default UISwitch;
